/**
 * @classdesc Persian Language Pack
 * @desc This class will used to translate tokens into the Persian language.
 * @namespace Languages.Persian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Persian
 */
export const dictionary = {
	'years'   : 'سال',
	'months'  : 'ماه',
	'days'    : 'روز',
	'hours'   : 'ساعت',
	'minutes' : 'دقیقه',
	'seconds' : 'ثانیه'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Persian
 */
export const aliases = ['fa', 'fa-ir', 'persian'];
